import React from "react"
import { Button } from "primereact/button"
import eccss from "../../../styles/ExternalCalls.module.css"

const PhoneKeypad = ({ onKeyPress, playSound }) => {

    const keypadLayout = [
        { label: "1", sub: "" },
        { label: "2", sub: "ABC" },
        { label: "3", sub: "DEF" },
        { label: "4", sub: "GHI" },
        { label: "5", sub: "JKL" },
        { label: "6", sub: "MNO" },
        { label: "7", sub: "PQRS" },
        { label: "8", sub: "TUV" },
        { label: "9", sub: "WXYZ" },
        { label: "*", sub: "" },
        { label: "0", sub: "+" },
        { label: "#", sub: "" }
    ]

    const playDTMF = (tone, duration = 150) => {
        const dtmfFrequencies = {
            '1': [697, 1209],
            '2': [697, 1336],
            '3': [697, 1477],
            '4': [770, 1209],
            '5': [770, 1336],
            '6': [770, 1477],
            '7': [852, 1209],
            '8': [852, 1336],
            '9': [852, 1477],
            '*': [941, 1209],
            '0': [941, 1336],
            '#': [941, 1477],
        }

        const freqs = dtmfFrequencies[tone]
        if (!freqs) return

        const context = new (window.AudioContext || window.webkitAudioContext)()
        const gainNode = context.createGain()
        gainNode.gain.value = 0.1

        freqs.forEach(frequency => {
            const osc = context.createOscillator()
            osc.frequency.value = frequency
            osc.type = 'sine'
            osc.connect(gainNode)
            gainNode.connect(context.destination)
            osc.start()
            osc.stop(context.currentTime + duration / 1000)
        })
    }

    return (
        <div className={eccss.keypadContainer}>
            {keypadLayout.map((key) => (
                <Button
                    key={key.label}
                    className={eccss.keypadButton}
                    onClick={() => {
                        if (playSound) {
                            playDTMF(key.label)
                        }
                        onKeyPress(key.label)
                    }}
                >
                    <div className={eccss.keypadContent}>
                        <div className={eccss.mainLabel}>{key.label}</div>
                        {key.sub && <div className={eccss.subLabel}>{key.sub}</div>}
                    </div>
                </Button>
            ))}
        </div>
    )
}

export default PhoneKeypad
